import { makeStyles } from '@mui/styles';

export const useTextFieldNoBorder = makeStyles(() => ({
  notchedOutline: {
    border: 'none',
  },
}));
